import { faSpinner } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "src/design-system/Icon";

type ChatLoadingSpinnerProps = {
  text: string;
  dataLoc?: string;
};

export const ChatLoadingSpinner: React.FC<ChatLoadingSpinnerProps> = ({
  text,
  dataLoc,
}) => (
  <div className="flex items-center gap-x-2" data-loc={dataLoc}>
    <Icon icon={faSpinner} size="xs" spin />
    <span className="font-inter-medium-11px text-gray-600">{text}</span>
  </div>
);
